export interface TrackJs {
  track(error: string): void;
  addMetadata(key: string, value: string): void;
  removeMetadata(key: string): void;
}
